//@ts-nocheck
//@ts-nocheck
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Heading,
  Link,
  ListItem,
  SimpleGrid,
  Stack,
  Text,
  List,
} from "@chakra-ui/react";
import React from "react";

const FAQItem = ({ question, children, ...rest }) => {
  return (
    <AccordionItem
      mb="6"
      rounded="md"
      bg="white"
      overflow="hidden"
      border="none"
      shadow="base"
      {...rest}
    >
      <AccordionButton bg="white">
        <Box
          flex="1"
          fontSize="xl"
          fontWeight="semibold"
          textAlign="left"
          p={5}
        >
          {question}
        </Box>
        <AccordionIcon fontSize="4xl" />
      </AccordionButton>
      <AccordionPanel>
        <Box p={5} fontSize="md">
          {children}
        </Box>
      </AccordionPanel>
    </AccordionItem>
  );
};

export const FAQs: React.FC<{ onClick?: any }> = ({ onClick }) => {
  return (
    <Box as="section" pb="20" bg="blue.900">
      <Box
        maxW={{ base: "xl", md: "1560px" }}
        mx="auto"
        px={{ base: "6", md: "8" }}
      >
        <Heading
          as="h1"
          pb={["6", "12"]}
          lineHeight="1.1"
          fontWeight="extrabold"
          fontSize={["3xl", "5xl"]}
          color="white"
        >
          Common questions
        </Heading>
        <SimpleGrid columns={{ base: 1, md: 2 }} spacingX={{ base: 8, md: 16 }}>
          <Accordion allowToggle>
            <FAQItem question="How do you select your tutors?">
              <Stack spacing={3}>
                <Text>
                  We take the following steps to ensure that our tutors are not
                  only subject matter experts, but are also inspiring
                  individuals who are safe to work with:{" "}
                </Text>
                <List spacing={3} pl={5}>
                  <ListItem fontSize="md">
                    <b>Profile review:</b> we start by reviewing tutors'
                    education, work, experience etc.
                  </ListItem>
                  <ListItem fontSize="md">
                    <b>Identity verification:</b> we verify government-issued
                    IDs, photos and bank details etc.
                  </ListItem>
                  <ListItem fontSize="md">
                    <b>Competency tests:</b> all tutors pass standard tests in
                    each subject they teach
                  </ListItem>
                  <ListItem fontSize="md">
                    <b>Personal interviews:</b> we conduct video and in-person
                    interviews with each tutor
                  </ListItem>
                  <ListItem fontSize="md">
                    <b>Guarantors check:</b> tutors successful in the above
                    steps provide up to 2 guarantors which we verify
                  </ListItem>
                  <ListItem fontSize="md">
                    <b>Continuous evaluation:</b> tutors with ratings below 3.8
                    are discontinued
                  </ListItem>
                </List>
              </Stack>
            </FAQItem>
            <FAQItem question="What happens after I select a plan?">
              <Stack>
                <Box>
                  A Learning Advisor will be in touch with you to further
                  discuss your needs and proceed to help you get the best and
                  most suitable tutors who match your requests.
                </Box>
                <Box>
                  You'll be able to review each tutor's profiles, reviews,
                  backgrounds, photos etc., and select a best fit for your
                  child. You won't pay until you've gotten a tutor.
                </Box>
              </Stack>
            </FAQItem>
            <FAQItem question="Are lessons online or in-person?">
              <Box>
                You decide if you want physical or online lessons, or a blend of
                both. You must have indicated this on your form. Clients from
                outside Nigeria will only have the option of online lessons.
                Online lessons are delivered over Zoom.
              </Box>
            </FAQItem>
            <FAQItem question="How does payment work?">
              <Stack>
                <Box>
                  Payments are designed to be easy and to protect both you and
                  your tutor. Upon selecting your preferred tutors, we collect
                  full payment for lessons ahead and credit same into your
                  e-wallet.
                </Box>
                <Box>
                  Tutors receive payments after all your lessons are delivered
                  and confirmed. This way, you can be guaranteed of quality
                  service and your tutors will be motivated to give their best
                  to your child.
                </Box>
              </Stack>
            </FAQItem>
          </Accordion>

          <Accordion allowToggle>
            <FAQItem question="How do refunds work at Tuteria?">
              <Stack>
                <Box>
                  We offer a prompt and transparent refund policy so that if you
                  decide to discontinue lessons, you'll be refunded the cost for
                  all lessons that haven't been delivered.
                </Box>
              </Stack>
            </FAQItem>
            <FAQItem question="Do I get any discounts?">
              <Stack>
                <Box>
                  Yes you do! You get a 5% discount off your total monthly fee
                  when you pay for 2 months in advance, and 10% discount when
                  you pay for 3 months in advance.
                </Box>
                <Box>
                  Many of our customers take this offer as it's a great way to
                  help you save and have lessons booked with your teacher for
                  the entire duration.
                </Box>
              </Stack>
            </FAQItem>
            <FAQItem question="What other services do you offer?">
              <Stack>
                <Box>
                  In addition to academic lessons, we can help you get the best
                  teachers for Professional, Local or International Exams; as
                  well as teachers for skills like Languages, Music, Coding etc.
                </Box>
              </Stack>
            </FAQItem>
            <FAQItem question="Who can I contact if I have questions?">
              <Stack>
                <Box>
                  Your Learning Advisor will be in touch with you over phone,
                  email and Whatsapp throughout the duration of the lessons to
                  provide progress report, customer support, resolve any issues
                  and ensure the smooth running of lessons.
                </Box>
                <Box>
                  However, if you wish to make a general enquiry, please feel
                  free to email us at:{" "}
                  <Link
                    fontWeight="medium"
                    color="blue.500"
                    href="mailto:info@tuteria.com"
                  >
                    info@tuteria.com
                  </Link>{" "}
                  or call{" "}
                  <Link
                    fontWeight="medium"
                    color="blue.500"
                    href="tel:2349094526878"
                  >
                    09094526878
                  </Link>
                </Box>
              </Stack>
            </FAQItem>
          </Accordion>
        </SimpleGrid>
      </Box>
    </Box>
  );
};
